import {ReactMount as Components} from './Libraries/bootstrap';

import './Libraries/Accordion/listener';
import './Libraries/Aos/listener';
import './Libraries/Article/listener';
import './Libraries/BlockContent/listener';
import './Libraries/BrowserWarning/listener';
import './Libraries/Form/index';
import './Libraries/GoogleMaps/index';
import './Libraries/Highlighter/listener';
import './Libraries/Lightbox/listener';
import './Libraries/MegaMenu/listener';
import './Libraries/ReadMore/listener';
import './Libraries/ScrollTo/listener';
import './Libraries/SimpleToggle';
import './Libraries/ShowMore/listener';
import './Libraries/StickyNav';
import './Libraries/Swiper/listener';
import './Libraries/TippyPopUp';
import './Libraries/VideoEmbed';
import './Libraries/VideoModal/listener';
import './Libraries/VideoStream/listener';

Components({
    Modal: () => import('./Libraries/Studios/modal'),
});
